// import React, { useState, useEffect, useRef } from "react";
// import CustomSearch from "./CustomSearch";

// const sizeClasses = {
//   xs: "px-2 py-0",
//   "xs-sm": "px-2.5 py-1",
//   sm: "px-3 py-1.5",
//   md: "px-3 py-2",
//   lg: "px-4 py-2.5",
//   xl: "px-5 py-3",
// };

// const fontSizeClasses = {
//   xs: "text-[12px]",
//   "xs-sm": "text-[12px]",
//   sm: "text-[12px]",
//   md: "text-[14px]",
//   lg: "text-[16px]",
//   xl: "text-[18px]",
// };

// const iconSizeClasses = {
//   xs: "!text-[12px]",
//   "xs-sm": "!text-[14px]",
//   sm: "!text-[14px]",
//   md: "!text-[14px]",
//   lg: "!text-[15px]",
//   xl: "!text-[15px]",
// };

// const CustomMultiSelect = ({
//   options = [],
//   value = [], // selected values
//   onChange = () => {},
//   showSelectAll = true,
//   rounded = "rounded",
//   disabled,
//   size = "md",
//   labelKey = "label", // field for display text
//   valueKey = "value", // field for unique value
//   placeholder = "Select options...",
//   noBorder = false,
//   showSearch = false,
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [searchValue, setSearchValue] = useState("");
//   const dropdownRef = useRef(null);
//   const buttonRef = useRef(null);

//   // Handle outside click to close dropdown
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const filteredOptions =
//     searchValue?.length > 0
//       ? options.filter((value) =>
//           value[labelKey].toLowerCase().includes(searchValue.toLowerCase())
//         )
//       : options;

//   const isOptionSelected = (option) => value.includes(option[valueKey]);

//   // Toggle single option
//   const handleSelect = (optionValue) => {
//     let newSelected;
//     if (value.includes(optionValue)) {
//       newSelected = value.filter((v) => v !== optionValue);
//     } else {
//       newSelected = [...value, optionValue];
//     }
//     onChange(newSelected);
//   };

//   // Toggle all options
//   const handleSelectAll = () => {
//     if (value.length === options.length) {
//       onChange([]);
//     } else {
//       onChange(options.map((opt) => opt[valueKey]));
//     }
//   };

//   const toggleDropdown = () => {
//     if (!disabled) {
//       setIsOpen(!isOpen);
//     }
//   };

//   return (
//     <div className="relative w-full" ref={dropdownRef}>
//       {/* Dropdown Button */}
//       <button
//         onClick={toggleDropdown}
//         className={`w-full  border border-gray-300 flex justify-between items-center hover:border-primary focus:border-primary focus:outline-none ${
//           sizeClasses[size]
//         } ${fontSizeClasses[size]} ${rounded} ${
//           disabled ? "bg-gray-200 cursor-not-allowed text-gray-600" : "bg-white"
//         } ${noBorder ? "border-0" : ""}
//         `}
//         type="button"
//         disabled={disabled}
//         ref={buttonRef}
//       >
//         <span
//           className={`truncate text-xm ${
//             value.length === 0 ? "text-gray-400" : "text-gray-700"
//           }`}
//         >
//           {value.length > 0
//             ? options
//                 .filter((opt) => value.includes(opt[valueKey]))
//                 .map((opt) => opt[labelKey])
//                 .join(", ")
//             : placeholder}
//         </span>
//         <span
//           className={`material-icons transition-transform ${iconSizeClasses[size]} ml-1 flex-shrink-0`}
//         >
//           {isOpen ? "expand_less" : "expand_more"}
//         </span>
//       </button>

//       {/* Dropdown Options */}
//       {isOpen && (
//         <div
//           style={{
//             position: "absolute",
//             width: buttonRef.current?.offsetWidth,
//           }}
//           className="mt-2 z-55 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto"
//         >
//           {showSearch && (
//             <div className="mx-2 mt-2">
//               <CustomSearch
//                 placeholder="Search"
//                 value={searchValue}
//                 onChange={(key, value) => setSearchValue(value)}
//                 size={size}
//                 rounded="rounded-full"
//               />
//               <hr className="mt-2 text-gray-300" />
//             </div>
//           )}

//           <ul className="p-2 space-y-1">
//             {showSelectAll && (
//               <li
//                 className={`flex items-center p-2 rounded cursor-pointer hover:bg-primary-50`}
//                 onClick={handleSelectAll}
//               >
//                 <input
//                   type="checkbox"
//                   checked={value.length === options.length}
//                   readOnly
//                   className="mr-2 cursor-pointer appearance-none h-4 w-4 border border-gray-300 rounded-sm checked:bg-primary checked:border-primary checked:after:content-['✓']
//                   checked:after:text-white checked:after:flex checked:after:items-center checked:after:justify-center checked:after:h-full checked:after:w-full checked:after:py-2"
//                 />
//                 <span>All</span>
//               </li>
//             )}
//             {filteredOptions.map((opt) => (
//               <li
//                 key={opt[valueKey]}
//                 className={`flex items-center p-2 rounded cursor-pointer hover:bg-primary-50`}
//                 onClick={() => handleSelect(opt[valueKey])}
//               >
//                 <input
//                   type="checkbox"
//                   checked={isOptionSelected(opt)}
//                   readOnly
//                   className="mr-2 cursor-pointer appearance-none h-4 w-4 border border-gray-300 rounded-sm checked:bg-primary checked:border-primary checked:after:content-['✓']
//                   checked:after:text-white checked:after:flex checked:after:items-center checked:after:justify-center checked:after:h-full checked:after:w-full checked:after:py-2"
//                 />
//                 <span>{opt[labelKey]}</span>
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CustomMultiSelect;

import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import ReactDOM from "react-dom";
import CustomSearch from "./CustomSearch";
import Button from "../../Buttons/Button";
import Chip from "../../Chip/Chip";
import { createPortal } from "react-dom";

const sizeClasses = {
  xs: "px-2 py-0",
  "xs-sm": "px-2.5 py-1",
  sm: "px-3 py-1.5",
  md: "px-3 py-2",
  lg: "px-4 py-2.5",
  xl: "px-5 py-3",
};

const fontSizeClasses = {
  xs: "text-[12px]",
  "xs-sm": "text-[12px]",
  sm: "text-[12px]",
  md: "text-[14px]",
  lg: "text-[16px]",
  xl: "text-[18px]",
};

const iconSizeClasses = {
  xs: "!text-[12px]",
  "xs-sm": "!text-[14px]",
  sm: "!text-[14px]",
  md: "!text-[14px]",
  lg: "!text-[15px]",
  xl: "!text-[15px]",
};

const CustomMultiSelect = ({
  options = [],
  value = [],
  onChange = () => {},
  showSelectAll = true,
  rounded = "rounded",
  disabled,
  size = "md",
  labelKey = "label",
  valueKey = "value",
  placeholder = "Select options...",
  noBorder = false,
  showSearch = false,
  showViewButton,
  onViewClick,
  shadow = false,
  style = "normal", // "normal" or "chip"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [visibleLabels, setVisibleLabels] = useState([]);
  const [hiddenCount, setHiddenCount] = useState(0);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const selectedLabelsRef = useRef(null);
  const dropdownContainerRef = useRef(null);

  // Handle outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownContainerRef.current &&
        !dropdownContainerRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (style === "chip" && value.length > 0 && selectedLabelsRef.current) {
      const calculateVisibleLabels = () => {
        const container = selectedLabelsRef.current;
        if (!container) return;

        const containerWidth = container.offsetWidth;
        const tempSpan = document.createElement("span");
        tempSpan.style.visibility = "hidden";
        tempSpan.style.position = "absolute";
        tempSpan.style.whiteSpace = "nowrap";
        tempSpan.style.fontSize = fontSizeClasses[size].replace("text-", "");
        document.body.appendChild(tempSpan);

        let totalWidth = 0;
        let visibleCount = 0;
        const selectedItems = options.filter((opt) =>
          value.includes(opt[valueKey])
        );

        for (let i = 0; i < selectedItems.length; i++) {
          const displayText =
            selectedItems[i][labelKey] || String(selectedItems[i][valueKey]);

          tempSpan.textContent = displayText;
          const textWidth = tempSpan.offsetWidth;

          const chipWidth = textWidth + 36;

          if (totalWidth + chipWidth <= containerWidth - 16) {
            totalWidth += chipWidth;
            visibleCount++;
          } else {
            break;
          }
        }

        document.body.removeChild(tempSpan);

        setVisibleLabels(selectedItems.slice(0, visibleCount));
        setHiddenCount(selectedItems.length - visibleCount);
      };

      setTimeout(calculateVisibleLabels, 0);

      const handleResize = () => {
        setTimeout(calculateVisibleLabels, 0);
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    } else if (style !== "chip") {
      setVisibleLabels([]);
      setHiddenCount(0);
    }
  }, [value, size, style, options, labelKey, valueKey]);

  const filteredOptions =
    searchValue?.length > 0
      ? options.filter((opt) =>
          opt[labelKey].toLowerCase().includes(searchValue.toLowerCase())
        )
      : options;

  const isOptionSelected = (option) => value.includes(option[valueKey]);

  // Toggle single option
  const handleSelect = (optionValue) => {
    let newSelected;
    if (value.includes(optionValue)) {
      newSelected = value.filter((v) => v !== optionValue);
    } else {
      newSelected = [...value, optionValue];
    }
    onChange(newSelected);
  };

  // Toggle all options
  const handleSelectAll = () => {
    if (value.length === options.length) {
      onChange([]);
    } else {
      onChange(options.map((opt) => opt[valueKey]));
    }
  };

  const toggleDropdown = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  // Handle chip removal
  const handleRemoveChip = (optionValue) => {
    const newSelected = value.filter((v) => v !== optionValue);
    onChange(newSelected);
  };

  // Handle view button click
  const handleViewClick = (e, optionValue) => {
    e.stopPropagation();
    if (onViewClick) {
      onViewClick(optionValue);
    }
  };

  // Get display value based on style
  const getDisplayValue = () => {
    if (style === "chip") {
      if (value.length === 0) {
        return <span className="text-gray-400">{placeholder}</span>;
      }

      return (
        <div
          ref={selectedLabelsRef}
          className="flex flex-wrap gap-1 items-center w-full"
        >
          {visibleLabels.map((option) => (
            <Chip
              key={option[valueKey]}
              label={option[labelKey] || String(option[valueKey])}
              size="xs"
              onDelete={() => handleRemoveChip(option[valueKey])}
            />
          ))}
          {hiddenCount > 0 && (
            <span className="text-gray-500 text-xs whitespace-nowrap">
              +{hiddenCount} more
            </span>
          )}
        </div>
      );
    } else {
      return (
        <span
          className={`truncate text-xm ${
            value.length === 0 ? "text-gray-400" : "text-gray-700"
          }`}
        >
          {value.length > 0
            ? options
                .filter((opt) => value.includes(opt[valueKey]))
                .map((opt) => opt[labelKey])
                .join(", ")
            : placeholder}
        </span>
      );
    }
  };

  useLayoutEffect(() => {
    if (isOpen && buttonRef.current && dropdownContainerRef.current) {
      const updatePosition = () => {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const dropdownRect =
          dropdownContainerRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;

        const spaceBelow = viewportHeight - buttonRect.bottom;
        const spaceAbove = buttonRect.top;

        const showBelow =
          spaceBelow >= Math.min(260, dropdownRect.height) ||
          spaceBelow >= spaceAbove;

        let left = buttonRect.left;
        if (left + dropdownRect.width > viewportWidth) {
          left = Math.max(0, viewportWidth - dropdownRect.width);
        }

        let top;
        if (showBelow) {
          top = buttonRect.bottom + 8;
          if (top + dropdownRect.height > viewportHeight) {
            top = viewportHeight - dropdownRect.height - 8;
          }
        } else {
          top = buttonRect.top - dropdownRect.height - 8;
          if (top < 0) {
            top = 8;
          }
        }

        dropdownContainerRef.current.style.left = `${left}px`;
        dropdownContainerRef.current.style.top = `${top}px`;
      };

      updatePosition();

      const handleScroll = () => {
        requestAnimationFrame(updatePosition);
      };

      window.addEventListener("scroll", handleScroll, true);
      window.addEventListener("resize", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll, true);
        window.removeEventListener("resize", handleScroll);
      };
    }
  }, [isOpen]);

  return (
    <div className="relative w-full">
      {/* Dropdown Button */}
      <button
        onClick={toggleDropdown}
        className={`w-full border flex justify-between items-center focus:outline-none ${
          sizeClasses[size]
        } ${fontSizeClasses[size]} ${rounded} 
        ${shadow ? "border-gray-50 inputShadow" : "border-gray-300"}
        ${
          disabled
            ? "border-neutrals-200 bg-neutrals-200 cursor-not-allowed text-black"
            : "bg-white hover:border-primary focus:border-primary"
        } ${noBorder ? "border-0" : ""}`}
        type="button"
        disabled={disabled}
        ref={buttonRef}
      >
        <div className="flex-1 overflow-hidden text-left">
          {getDisplayValue()}
        </div>
        <span
          className={`material-icons transition-transform ${iconSizeClasses[size]} ml-1 flex-shrink-0`}
        >
          {isOpen ? "expand_less" : "expand_more"}
        </span>
      </button>

      {/* Dropdown (rendered in portal) */}
      {isOpen &&
        createPortal(
          <div
            ref={dropdownContainerRef}
            style={{
              position: "fixed",
              width: buttonRef.current?.offsetWidth,
              zIndex: 53,
            }}
            className="mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto"
          >
            {showSearch && (
              <div className="mx-2 mt-2">
                <CustomSearch
                  placeholder="Search"
                  value={searchValue}
                  onChange={(key, val) => setSearchValue(val)}
                  size={size}
                  rounded="rounded-full"
                />
                <hr className="mt-2 text-gray-300" />
              </div>
            )}

            <ul className="p-2">
              {showSelectAll && (
                <li
                  className={`flex items-center ${
                    showViewButton ? "p-1" : "p-2"
                  } rounded cursor-pointer hover:bg-primary-50`}
                  onClick={handleSelectAll}
                >
                  <input
                    type="checkbox"
                    checked={value.length === options.length}
                    readOnly
                    className="mr-2 cursor-pointer appearance-none h-4 w-4 border border-gray-300 rounded-sm checked:bg-primary checked:border-primary checked:after:content-['✓'] 
                    checked:after:text-white checked:after:flex checked:after:items-center checked:after:justify-center checked:after:h-full checked:after:w-full checked:after:py-2"
                  />
                  <span className={`${fontSizeClasses[size]}`}>All</span>
                </li>
              )}
              {filteredOptions.map((opt) => (
                <li
                  key={opt[valueKey]}
                  className={`flex justify-between items-center ${
                    showViewButton ? "p-1" : "p-2"
                  }  rounded cursor-pointer hover:bg-primary-50`}
                >
                  <div
                    className="flex items-center flex-1"
                    onClick={() => handleSelect(opt[valueKey])}
                  >
                    <input
                      type="checkbox"
                      checked={isOptionSelected(opt)}
                      readOnly
                      className="mr-2 cursor-pointer appearance-none h-4 w-4 border border-gray-300 rounded-sm checked:bg-primary checked:border-primary checked:after:content-['✓'] 
                    checked:after:text-white checked:after:flex checked:after:items-center checked:after:justify-center checked:after:h-full checked:after:w-full checked:after:py-2"
                    />
                    <span className={`flex-1 ${fontSizeClasses[size]}`}>
                      {opt[labelKey]}
                    </span>
                  </div>
                  {showViewButton && (
                    <Button
                      icon={"visibility"}
                      size={size}
                      type="icon"
                      color="black"
                      variant="text"
                      onClick={(e) => handleViewClick(e, opt[valueKey])}
                    />
                  )}
                </li>
              ))}
            </ul>
          </div>,
          document.body
        )}
    </div>
  );
};

export default CustomMultiSelect;
